import React, { Component, PropTypes } from 'react';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import { BASE_URL } from '../../config';
import Modal from '../Modal';
import {token} from '../../libs/localStorage';

export default class ItemRelatedFileAdd extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };
  slug;
  title = 'Add Item Related File';

  constructor(props) {
    super(props);
    this.slug = `/station/${props.params.id}/inventory`;
    this.onOpenClick = this.onOpenClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  onOpenClick() {
    this.refs.dropzone.open();
  }

  onDrop(files) {
    const url = `${BASE_URL}/api/inventory/item/${this.props.params.itemId}/file/upload`;
    const {notify, router} = this.context;

    const req = request
      .post(url)
      .set('Authorization', `Bearer ${token.getEncoded()}`);

    files.forEach(file => {
      req.attach('photo', file);
    });
    req.end((err, res) => {
      if(!err){
        router.replace(this.slug);
        notify.success(JSON.parse(res.text));
        this.props.fetchSelectedItem(this.props.params.itemId)
      } else {
        router.replace(this.slug);
        notify.error({message: err});
      }
    });
  }

  render() {
    return (
      <Modal title={this.title} slug={this.slug}>
        <div>
          <ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }}>
            <div>Try dropping a file here, or click to select a file to upload.</div>
          </ReactDropzone>
          <button type="button" className="button small" onClick={this.onOpenClick}>
            Add File
          </button>
        </div>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Inventory/ItemRelatedFileAdd.js